var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{style:({ 'opacity': _vm.opacity }),attrs:{"frame":"iphone-reg-frame","page":_vm.page,"matchContent":_vm.matchContents},on:{"answer":_vm.answer,"reset":_vm.reset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }